import { forwardRef, memo, type ForwardedRef, type ReactNode } from 'react';

import { Loader } from '../../Elements/Loader/index.tsx';
import { Item } from './components/Item/index.tsx';
import { LoaderSlot, Wrapper } from './styled.ts';
import type { SegmentedControlProps } from './types.ts';

type SegmentedControlComponentType = <TValue>(props: SegmentedControlProps<TValue> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactNode;

export const SegmentedControl = memo(
  forwardRef(function SegmentedControl<TValue>(props: SegmentedControlProps<TValue>, ref: ForwardedRef<HTMLDivElement>) {
    const { options, selectedValue, onChange, isOptionSelected, disabled, isLoading, formatOptionLabel, dataTestId, numberOfColumns } =
      props;
    const columns = numberOfColumns ?? options.length;

    return (
      <Wrapper ref={ref} data-testid={dataTestId} $numberOfColumns={columns} $disabled={disabled}>
        {isLoading ? (
          <LoaderSlot $disabled={disabled}>
            <Loader />
          </LoaderSlot>
        ) : (
          options.map((option, index) => (
            <Item
              key={String(option.value)}
              option={option}
              selectedValue={selectedValue}
              columns={columns}
              index={index}
              totalCount={options.length}
              allDisabled={disabled}
              isOptionSelected={isOptionSelected}
              onChange={onChange}
              formatOptionLabel={formatOptionLabel}
            />
          ))
        )}
      </Wrapper>
    );
  }),
) as SegmentedControlComponentType;
